<template>
    <div class="block-modal">
        <el-button type="success" @click="dialogVisible = true">{{ $t('moreLanguage.chooseTemplate') }}</el-button>
      <el-dialog
          :title="$t('moreLanguage.settingTemplate')"
          :visible.sync="dialogVisible"
          width="31%">
        <div>
          <el-row class="mb-3">
            <el-col :span="8">
              <span class="required-star">* </span><span class="form-lable"> {{$t('moreLanguage.chooseTemplate')}}</span>
            </el-col>
            <el-col :span="16">
              <div>
                <select class="input"  v-model="data.template_id" @change="changeTemplate()">
                  <option value="">{{$t('moreLanguage.chooseTemplate')}}</option>
                  <option v-for="place in listTemplate" v-bind:key="place.id" :value="place.id">{{ place.name }}</option>
                </select>
              </div>
              <div v-if="errorInfo.template_id" class="text-danger text-errors">{{errorInfo.template_id}}</div>
            </el-col>
          </el-row>

          <el-row class="mb-3">
            <el-col :span="8">
              <span class="required-star">* </span><span class="form-lable"> {{$t('moreLanguage.chooseType')}}</span>
            </el-col>
            <el-col :span="16">
              <div>
                <select class="input"  v-model="data.type_template">
                  <option value="">{{$t('moreLanguage.chooseType')}}</option>
                  <option v-for="place in template_type" v-bind:key="place.value" :value="place.value">{{ $t(place.text) }}</option>
                </select>
              </div>
              <div v-if="errorInfo.type_template" class="text-danger text-errors">{{errorInfo.type_template}}</div>
            </el-col>
          </el-row>

          <el-row class="mb-3"  v-if="data.type_template === FOLLOWDAY">
            <el-col :span="8">
              <span class="required-star">* </span><span class="form-lable"> {{$t('moreLanguage.date')}}</span>
            </el-col>
            <el-col :span="16" >
              <div>
                <el-date-picker :picker-options="datePickerOptions"
                                v-model="data.date"
                                type="date" class="w-100"
                                :placeholder="$t('common.pick_a_day')" >
                </el-date-picker>
              </div>
              <div v-if="errorInfo.date" class="text-danger text-errors">{{errorInfo.date}}</div>
            </el-col>
          </el-row>

          <el-row class="mb-3" v-if="data.type_template === FOLLOWRANGERDAY">
            <el-col :span="8">
              <span class="required-star">* </span><span class="form-lable"> {{$t('moreLanguage.startDate')}}</span>
            </el-col>
            <el-col :span="16">
              <el-date-picker :picker-options="datePickerOptions"
                              v-model="data.date_start"
                              type="date" class="w-100"
                              :placeholder="$t('common.pick_a_day')" >
              </el-date-picker>
              <div v-if="errorInfo.date_start" class="text-danger text-errors">{{errorInfo.date_start}}</div>
            </el-col>
          </el-row>
          <el-row class="mb-3" v-if="data.type_template === FOLLOWRANGERDAY">
            <el-col :span="8">
              <span class="required-star">* </span><span class="form-lable">  {{$t('moreLanguage.endDate')}}</span>
            </el-col>
            <el-col :span="16">
              <div>
                <el-date-picker :picker-options="datePickerOptions"
                                v-model="data.date_end"
                                type="date" class="w-100"
                                :placeholder="$t('common.pick_a_day')" >
                </el-date-picker>
              </div>
              <div v-if="errorInfo.date_end" class="text-danger text-errors">{{errorInfo.date_end}}</div>
            </el-col>
          </el-row>
        </div>
        <span slot="footer" class="dialog-footer">
                 <el-button type="danger" @click="dialogVisible = false">{{$t('common.cancel')}}</el-button>
                <el-button type="primary" @click="save()">{{$t('common.submit')}}</el-button>
            </span>
      </el-dialog>
    </div>

</template>

<script>
    import {FOLLOWDAY, FOLLOWRANGERDAY, GENERATE_DEADLINE_TIME_DROP} from "../../config";

    export default {
        name: "PopupChooseTemplate",
        data() {
            return {
              errorInfo: {
                template_id: '',
                date: '',
                date_start: '',
                date_end: '',
              },
                data: {
                    type_template: FOLLOWDAY,
                    template_id: '',
                    date: this.$moment( new Date()).format('YYYY-MM-DD'),
                    date_start: '',
                    date_end: '',
                    selectList: []
                },
                FOLLOWDAY: FOLLOWDAY,
                FOLLOWRANGERDAY: FOLLOWRANGERDAY,
                datePickerOptions: {
                  disabledDate (time) {
                    return time.getTime() <= (Date.now() - 86400 * 1000)
                  }
                },
                dialogVisible: false,
                listTemplate: [],
                template_type: [
                    {
                        text: 'moreLanguage.followDay',
                        value: FOLLOWDAY
                    },
                    {
                        text: 'moreLanguage.followRangerDay',
                        value: FOLLOWRANGERDAY
                    }
                ],
            };
        },
        mounted() {
            let dateNow = new Date()
            let dateExpired = new Date(this.$moment(dateNow).format('YYYY-MM-DD') + ' '+ GENERATE_DEADLINE_TIME_DROP)
            let dateStart = new Date(this.$moment(dateNow).format('YYYY-MM-DD') + ' 00:00')
            if(dateNow.getTime() > dateExpired.getTime()){
                // let dat = this.$moment(dateNow)
                // this.data.date = dat.subtract(1, 'days').format('YYYY-MM-DD')
                this.datePickerOptions = {

                    disabledDate (date) {
                        return date.getTime() < dateStart.getTime()
                    }
                }
            }
            if(dateNow.getTime() > dateExpired.getTime()){
                let dat1 = this.$moment(dateNow)
                this.data.date = dat1.add(1, 'days').format('YYYY-MM-DD')
                this.datePickerOptions = {
                    disabledDate (date) {
                        return date.getTime() <= dateStart.getTime()
                    }
                }
            }

            this.getMasterTemplate()
        },
        methods: {
          resetError(){
            let errorInfo= {
              template_id: '',
              date: '',
              date_start: '',
              date_end: '',
            }
            this.errorInfo = errorInfo
          },
          validate(){
            this.resetError()
            const {data} = this
            let check = true
            if(data.template_id==="" || this.errorInfo.template_id === null){
              check = false
              this.errorInfo.template_id = this.$t('msg.requiredSelect', {field: this.$t('moreLanguage.chooseTemplate') })
            }else{
              this.errorInfo.template_id = ""
            }
            if(data.type_template ===0 || data.type_template===1){
              if(data.type_template === FOLLOWDAY){
                if(data.date==="" || data.date === null){
                  check = false
                  this.errorInfo.date = this.$t('msg.requiredSelect', {field: this.$t('moreLanguage.date') })
                }else{
                  this.errorInfo.date = ""
                }
              }else{
                if(data.date_end==="" || this.errorInfo.date_end === null){
                  check = false
                  this.errorInfo.date_end = this.$t('msg.requiredSelect', {field: this.$t('moreLanguage.endDate') })
                }else{
                  this.errorInfo.date_end = ""
                }
                if(data.date_start==="" || this.errorInfo.date_start === null){
                  check = false
                  this.errorInfo.date_start = this.$t('msg.requiredSelect', {field: this.$t('moreLanguage.startDate') })
                }else{
                  this.errorInfo.date_start = ""
                }
                if(data.date_start &&data.date_end ){
                  let endDate = data.date_end ? new Date(data.date_end).getTime() : 0
                  let startDate = data.date_start ? new Date(data.date_start).getTime() : 0
                  if(endDate <= startDate) {
                    check = false
                    this.errorInfo.date_end = this.$t('msg.dateFromTo')
                  }
                }
              }
            }else{
              check = false
              this.errorInfo.type_template = this.$t('msg.requiredSelect', {field: this.$t('moreLanguage.chooseType') })
            }

            return check
          },
            changeTemplate(){
              let index = this.listTemplate.findIndex(x=>{
                 return  x.id === this.data.template_id
              })
                this.data.selectList = this.listTemplate[index].data_list
            },
            save(){
              let check = this.validate()
              if(check) {
                this.$store.dispatch('schedule/getDetailTemplate', {
                  data: {
                    id: this.data.template_id
                  },
                  successCallback: (response) => {
                    let templateInfo = response.data.data.template_info

                    let data = Object.assign({}, this.data)
                    data.date = this.$moment(data.date).format('YYYY-MM-DD')
                    data.date_start = this.$moment(data.date_start).format('YYYY-MM-DD')
                    data.date_end = this.$moment(data.date_end).format('YYYY-MM-DD')
                    data.selectList = templateInfo.data_list

                    this.$emit('addTemplate', data)

                    this.dialogVisible = false
                  }
                })
              }
            },
            getMasterTemplate(){
                let successCallback = (response) => {
                    this.listTemplate = response.data.data.template_list
                    this.loading = false
                }
                let errorCallback = (error) => {
                    this.loading = false
                    this.$notify({
                        title: this.$t('msg.titleError'),
                        message: error.response.data.message,
                        type: 'error'
                    })
                }
                let payload = {
                    successCallback,
                    errorCallback
                }
                this.$store.dispatch('schedule/getMasterTemplate', payload)
            }
        }
    };
</script>

<style lang="scss">
    .block-modal{
        .el-dialog{
            border-radius: 6px;
        }
        .el-dialog__header {
            padding: 0;
            background: #213F9A;
            .el-dialog__title{
                color: #fff;
            }
            .el-dialog__headerbtn{
                display: none;
            }
        }
        .w-100{
            width: 100%;
        }
        .form-lable{
            font-size: 14px;
        }
    }
</style>
